<template>
  <div class="input-with-buttons" :class="{'input-with-buttons_danger': danger}">
    <input type="text"
           class="input-with-buttons__input"
           v-model="model"
           @keypress="$validateInput($event, type)"
           @keypress.enter="$emit('accept')"
           :disabled="disabled"
    >

    <div class="input-with-buttons__button"
         :class="{'input-with-buttons__button_disabled': disabled}"
         @click="accept"
         title="Сохранить"
    >
      <app-icon name="SaveIcon" size="1.28rem" style="color: rgba(var(--app-success), 1)"/>
    </div>
    <div class="input-with-buttons__button input-with-buttons__button_last"
         :class="{'input-with-buttons__button_disabled': disabled}"
         @click="cancel"
         title="Сбросить изменения"
    >
      <app-icon name="XIcon" size="1rem" style="color: rgba(var(--app-danger), 1)"/>
    </div>

    <transition name="fade">
      <div class="input-with-buttons__validation-error" v-if="danger && dangerText.length">
        {{dangerText}}
      </div>
    </transition>


  </div>
</template>

<script>
  export default {
    name: "InputTwoButtons",
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      danger: {
        type: Boolean,
        default: false
      },
      dangerText: {
        type: String,
        default: ""
      },
      type: {
        default: 'text',
        type: String
      },
      value: {}
    },
    computed: {
      model: {
        get(){
          return this.value;
        },
        set(v){
          let value = v.length === 0 ? null : v;
          if(value !== null && (this.type === 'double' || this.type === 'udouble')){
            value = value.replace(/,/g, '.');
          }
          this.$emit('input', value);
          this.$emit('update:danger', false);
        }
      }
    },
    methods: {
      accept(){
        if(this.disabled) return false;
        this.$emit('accept');
      },
      cancel(){
        if(this.disabled) return false;
        this.$emit('cancel');
      }
    }
  }
</script>

<style lang="scss">
.input-with-buttons{
  display: flex;
  width: 100%;
  position: relative;

  &_danger{
    .input-with-buttons__input{
      border: 1px solid rgba(var(--app-danger), 1);
    }
  }

  &__input{
    appearance: none;
    flex: 1 1 auto;
    display: block;
    width: 0;
    max-width: 100%;
    padding: 5px 10px;
    border: 1px solid #ced4da;
    border-right-color: transparent;
    border-radius: 2px 0 0 2px;
    font: inherit;
    font-size: 1rem;
    line-height: 14px;
  }


  &__button{
    flex: 0 0 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ced4da;
    background-color: #f8f9fa;

    &_last{
      border-radius:  0 2px 2px 0;
    }

    &:not(.input-with-buttons__button_disabled):hover{
      cursor: pointer;
      background-color: #f2f2f2;
    }

    &.input-with-buttons__button_disabled:hover{
      cursor: not-allowed;
    }


    &+&{
      border-left: none;
    }
  }
  &__validation-error{
    display: inline-block;
    color: rgba(var(--app-danger), 1);
    overflow: hidden;
    transition: all .25s ease;
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
    margin-top: 3px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 4px;
    line-height: 1.2;
    font-size: 10px;
    border-radius: 2px;
    z-index: 100;
    position: absolute;
    top: 100%;
    left: 0;
  }
}
</style>
